import * as React from 'react';
import { TableChorinitia } from '../../genericComponents/TableChorinitia/TableChorinitia';
import * as ReqType from '../../../types/ServerRequests';
import { LigneEvent } from './LigneEvent';

export interface Props {
    listEvent: ReqType.Event[];
}

interface State {
}
/**
 * Ce composant permet l'affichage d'une liste d'evente
 */
export class ListeEvent extends React.Component {
    props: Props;
    state: State;

    constructor(props: Props) {
        super(props);
    }

    render() {
        // alert(' ' + this.state.listUser.length + ' ');
        const listItems = this.props.listEvent.map(
            (event: ReqType.Event) => {
                // alert(event.date_heure_debut.toLocaleDateString());
                return (
                    <LigneEvent
                        event={event}
                        key={event.id}
                    />
                );

            }
        );

        return (
            <div className="card card-default">
                <div className="card-header col-12">
                    <h4 className="text-white">
                        <strong> Mes Evenements </strong>
                    </h4>
                </div>
                <div className="card-body"  style={{overflow: 'auto', maxHeight: '700px'}}>
                    <TableChorinitia
                        header={
                            <thead className="thead-light">
                                <tr>
                                    <th scope="col">Id</th>
                                    <th scope="col">Intitulé</th>
                                    <th scope="col">Description</th>
                                </tr>
                            </thead>
                        }
                    >
                        <tbody>
                            {listItems}
                        </tbody>
                    </TableChorinitia>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ProfilePage/internalComponents/ListeEvent.tsx